export default "<template>\n  <div className=\"editable-sample-edge-label\"></div>\n</template>\n\n<script>\nexport default {\n  setup() {},\n};\n</script>\n";